export var getAuthorizationHeader = function (_a) {
    var rsession = _a.rsession, brandId = _a.brandId, brandName = _a.brandName, applicationId = _a.applicationId, returnUrl = _a.returnUrl, token = _a.token;
    return ({
        Authorization: token ?
            "Bearer ".concat(token) :
            "".concat(rsession ? "rsession=".concat(rsession) : "", ",brandName=").concat(brandName, ",brandId=").concat(brandId, ",yccUrl=").concat(returnUrl, ",appId=").concat(applicationId)
    });
};
//# sourceMappingURL=api.js.map